import { useMemo, useState } from 'react'

import { TableContext } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/TableContext'

import type { TableContextType } from 'app/KinerjaTimPenilaiPSPage/components/Penetapan/TablePenetapan/TableContext'

type ProviderProps = Pick<TableContextType, 'data' | 'meta' | 'isFetching'> & {
  children?: React.ReactNode
}

export function Provider({ children, data, meta, isFetching }: ProviderProps) {
  const pengawasSekolahList = useMemo(() => data?.pengawasSekolah ?? [], [data])
  const isAllSentToPPK = useMemo(() => {
    return meta?.total === meta?.totalSentToPpk
  }, [meta])
  const selectableIds = useMemo(
    () =>
      pengawasSekolahList
        .filter((item) => ['NOT_SENT', 'ERROR_SEND'].includes(item.status))
        .map((item) => item.pengawasSekolahId),
    [pengawasSekolahList]
  )

  // --------------------
  // Handle toobar action
  // --------------------
  const [hasOngoingAction, setHasOngoingToolbarAction] = useState(false)

  // ----------------------------
  // Handle selected items toggle
  // ----------------------------
  // Use Set instead of Array for efficient data lookup
  const [selectedIds, setSelectedIds] = useState(new Set<string>([]))

  const handleToggle = (pengawasSekolahId: string, isChecked: boolean) => {
    setSelectedIds((prev) => {
      // Create a new Set based on the previous Set to avoid mutation
      const newSet = new Set(prev)

      if (isChecked) {
        newSet.add(pengawasSekolahId)
      } else {
        newSet.delete(pengawasSekolahId)
      }

      return newSet
    })
  }
  const handleToggleAll = (isChecked: boolean) => {
    if (isChecked) {
      setSelectedIds(new Set(selectableIds))
    } else {
      setSelectedIds(new Set([]))
    }
  }

  return (
    <TableContext.Provider
      value={{
        hasOngoingAction,
        isFetching,
        data,
        meta,
        pengawasSekolahList,
        isAllSentToPPK,
        selectedIds,
        selectableIds,
        onToggle: handleToggle,
        onToggleAll: handleToggleAll,
        onSetHasOngoingAction: setHasOngoingToolbarAction,
      }}
    >
      {children}
    </TableContext.Provider>
  )
}
